import { Injectable } from '@angular/core';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';
import { FeaturesService } from './features.service';

@Injectable({
  providedIn: 'root',
})
export class LicenseGuardService {
  constructor(
    private featuresService: FeaturesService,
    private broadcaster: BroadcasterService,
  ) {}

  init() {
    this._initBroadcaster();
  }

  private _initBroadcaster() {
    this.broadcaster.on(FeaturesService.FEATURE_INTERACTIVE_DISPLAYS, () => {
      this._checkInteractiveLicenses();
    });
  }

  private async _checkInteractiveLicenses() {
    try {
      const hasLicense = this.featuresService.hasInteractiveLicensing();
      if (!hasLicense) {
        this.featuresService.showUpgradePlanModal(
          FeaturesService.FEATURE_INTERACTIVE_DISPLAYS,
        );
      }
    } catch (error) {
      console.error(
        'Show Upgrade Plan Modal dismissed for: Interactive Displays',
      );
    }
  }
}
